<script lang="ts" context="module">
    let keyedPagePopWords: PopWords | null = null
    export const setKeyedPagePopWords = (popWords: PopWords | null) =>
        (keyedPagePopWords = popWords)
</script>

<script lang="ts">
    import { fromRange, getMeta, weigh } from "@circleofa/acim-engine"
    import { fade } from "svelte/transition"
    import type { DisplayWord } from "@circleofa/acim-engine"
    import { isRenderable, isSlippable, slip } from "@circleofa/acim-engine"
    import type { Renderable } from "@circleofa/acim-engine"
    import { onDestroy, onMount, setContext, tick } from "svelte"
    import { get, type Writable, writable } from "svelte/store"
    import { clickTouchOverride } from "@utils/directives/touchHandler"
    import NextButton from "@components/rendering/NextButton.svelte"
    import { blink } from "@utils/material/blink"
    import Footnotes, { footnotes, footnote } from "@components/footnotes/Footnotes.svelte"
    import {
        selectedTab,
        setPath,
        movingToTab,
        unsetcurrentPageOrRenderItemPath,
        setScroll,
        switchedTabOnSamePlace,
        isTabPath,
        isTabItem,
        formatTabPath,
    } from "@store/pageTracker"
    import { headerAnimationsReady } from "@components/TopBar/TopBar.svelte"
    import { styleFontSize } from "@store/deviceSettings"
    import { watchParagraphs } from "@utils/directives/useWatchParagraph"
    import { awaitStore } from "@utils/helpers/await-store"
    import { awaitSizeSettled } from "@utils/helpers/await-size-settled"
    import { audioItem, setupAudioOnNode, stop } from "@utils/audiobook/audiobook"
    import { scrollTopListener } from "@utils/directives/useScrolltop"
    import { navigatorOpen, navigatorWidth } from "@components/navigator/Navigator.svelte"
    import { acim } from "@utils/acim"
    import { page as pageStore } from "$app/stores"
    import { goto } from "$app/navigation"
    import { AnimationRunner } from "@utils/helpers/animator"
    import { convertRangePathToURLPath } from "@utils/fallback-book-redirection"
    import {
        RedrawEventDispatcher,
        attachHighlighterListener,
        contextScrollContainerClass,
    } from "@utils/highlights/directive-logic/highlights-directive"
    import { scrollLockClass } from "@utils/highlights/directive-logic/scroll-locker"
    import { StorePender } from "@utils/helpers/store-pender"
    import { getOffsetTopToParent } from "@utils/helpers/offset-to-parent"
    import { ScrollHelper } from "@utils/helpers/scroll-helper"
    import type { PopWords } from "@utils/highlights/directive-logic/highlight-listener-permissions"
    import ReadingFrameHeader from "./ReadingFrameHeader.svelte"
    import ReadingContentsButton from "./ReadingContentsButton.svelte"
    import { htmlRenderItems } from "@utils/reading/render"
    import Player from "@components/audiobook/Player.svelte"
    import ReaderFocusExitButton from "./ReaderFocusExitButton.svelte"
    import { exitReaderFocus, readerFocusMode } from "@utils/reading/reader-focus"
    import { enableReaderGestures, type ReaderPinchEvent } from "@utils/reading/reader-gesture"
    import { registerHotKeyTap } from "@utils/underhood/registerHotkey"
    import { sideMenuOpen } from "@components/navigator/SideMenu.svelte"
    import { globalSelectHandler } from "@utils/highlights/directive-logic/global-select-handler"

    // There's a lot of qwerky  things in this page,
    // because there's a lot of moving parts, and different ways
    // one might access a page (ie, moving from a tab, or not in a tab at all,
    // or straight from the browser URL, etc). I want this to be organized,
    // but there's only so much I can do

    // let page: Renderable | null = null
    // let message: string = ""

    // let disableForReset = true
    // let renderable = false

    // let lastURL: string = ""
    // // let bookstyle = false // book style formatting for cameos, hides numbers and paragraphs rendered different
    // let lastHashtag: string = ""
    // let loading = false
    // let container: HTMLDivElement
    // let scrollContainer: HTMLElement
    // let pageAndScrollAlreadySaved = true

    // let mounted = false
    // onMount(() => (mounted = true))

    // // TODO set metadata
    // // /**
    // //  * Set metatags for current page. Call when we know what page this is
    // //  * @param current renderable
    // //  */
    // // function setMetaTags(current : Renderable) {
    // //     if (!metatags) return
    // //     const meta = getMeta(current)
    // //     metatags.title = meta.title
    // //     metatags.description = meta.description
    // //     metatags.url = window.location
    // // }
    // // $: if (renderable && page && mounted) setMetaTags(page)

    // // Reset is called when there is a change in PARAMS, meaning URL change
    // async function reset() {
    //     // First we see if params is set
    //     if (!$pageStore.params.notation) {
    //         return
    //     }

    //     // Then we see if the url is where we already are
    //     if ($pageStore.params.notation == lastURL) {
    //         // Update: always scroll to hash no matter what
    //         processHash()

    //         // if (lastHashtag != location.hash) {
    //         //     // We're in the same page, but there is a new hash, so let's scroll to it
    //         //     lastHashtag = location.hash
    //         //     processHash()
    //         // } else if ($movingToTab) {
    //         //     processHash()
    //         // }
    //         // And then we're done
    //         return
    //     }

    //     // So we know we're at a different place with a different hash, so let's track this in our history
    //     lastHashtag = location.hash
    //     lastURL = $pageStore.params.notation

    //     // Enable loader again, just in case we missed the first one at hash change
    //     loading = true

    //     // Disable removes the current page and allows thingy
    //     disableForReset = true
    //     await awaitStore(htmlLoaded, (b) => !b)

    //     // Reset all data
    //     // if ($highlightsMap) $highlightsMap.unsubscribe()
    //     message = ""
    //     page = null
    //     renderable = false
    //     const notation = $pageStore.params.notation

    //     try {
    //         const fullPath = convertRangePathToURLPath(notation)
    //         // Simple test - if the fullPath URL matches the notation, it means it's a renderable
    //         if (fullPath !== notation) goto("/book/" + fullPath)

    //         const res = acim.find(fullPath)

    //         if (!isRenderable(res)) {
    //             throw new Error(
    //                 `Fullpath and notation match, but it's not a renderable! fullPath: ${fullPath} notation: ${notation}`
    //             )
    //         }

    //         page = res
    //         renderable = true
    //         $pageInNavigator = page // for top navigator
    //         $footnote = null
    //         $footnotes = page.footnotes

    //     } catch (err) {
    //         console.warn("Whoops! An error occured: ", err)
    //         // Is this error processing good enough?
    //         renderable = false
    //         message = "" + err
    //         disableForReset = false
    //         return
    //     }

    //     //
    //     // By this point we've determined that it is a renderable page, so we're set to go
    //     //

    //     //
    //     //  Tab logic, setting scroll and the rest
    //     //

    //     // If we're not moving a tab, we can go ahead
    //     if (!$movingToTab) {
    //         setScroll(scrollContainer.scrollTop)
    //     }

    //     // We don't want the function to save if we're moving to a tab, because
    //     // we'll just be saving where the tab already is
    //     // but we do want to inform the general app where we are for other things
    //     // like the top nav bar
    //     if (page)
    //         setPath(
    //             formatTabPath(page, location.hash.substring(1)),
    //             true,
    //             !$movingToTab
    //         )

    //     // This is to let processScrollLogic know that we've already processed setPath and setScroll
    //     pageAndScrollAlreadySaved = true

    //     // Await for header animation to complete
    //     await awaitStore(headerAnimationsReady)
    //     // All vars ready to go so let's dismount what we have currently
    //     disableForReset = false

    //     // Wait for it all to load and then scroll if it makes sense. This will call all the onMounts of the children
    //     // await tick()

    //     // // console.log("waiting for tick?")

    //     // // If we're scrolling somewhere, process it. If not, don't.
    //     // if (location.hash.length) {
    //     //     await processHash()
    //     // } else {
    //     //     if (container) scrollContainer.scrollTop = 0
    //     // }
    //     $movingToTab = false
    //     loading = false
    // }

    // // params doesn't trigger when the url is the same,
    // // hence switchedTab lets us know when there's that exceptional case
    // // TODO: make sure this fires properly
    // $: {
    //     $pageStore
    //     $switchedTabOnSamePlace
    //     reset()
    // }

    // async function processHash() {
    //     try {
    //         // check to see if we can scroll exactly to where we left off (if same device)
    //         if (
    //             $selectedTab &&
    //             $movingToTab &&
    //             $selectedTab.scrollAmount !== undefined
    //         ) {
    //             scrollContainer.scrollTo(0, $selectedTab.scrollAmount)
    //         } else {
    //             const [one, two] = acim.fromRange(location.hash.substring(1))

    //             // if (elements.length && elements.length != $wordmap.size) {
    //             //     // We don't want to blink the whole page

    //             //     await awaitSizeSettled(scrollContainer)

    //             //     const viewportHeight = scrollContainer.clientHeight // ~ 650 on mobile
    //             //     const scrollTop = container.getBoundingClientRect().top
    //             //     const elementTop = elements[0].getBoundingClientRect().top
    //             //     const difference = elementTop - scrollTop
    //             //     const quarterViewport = viewportHeight / 6
    //             //     const totalScroll = difference - quarterViewport

    //             //     scrollContainer.scrollTo({
    //             //         behavior: $movingToTab ? "auto" : "smooth",
    //             //         top: totalScroll,
    //             //     })
    //             //     if (!$movingToTab) {
    //             //         const observer = new IntersectionObserver((list) => {
    //             //             list.forEach((e) => {
    //             //                 if (e.isIntersecting) {
    //             //                     observer.disconnect()
    //             //                     elements.forEach((e) => blink(e))
    //             //                 }
    //             //             })
    //             //         })
    //             //         observer.observe(elements[0])
    //             //     }
    //             // } else {
    //             //     scrollContainer.scrollTo(0, 0)
    //             // }
    //         }
    //     } catch (e) {}
    // }

    // // This tracks user scrolling exact X position and saves it, it's
    // // more intuitive than scrolling to the notation ID if we know we're on the same device
    // const processScrollTabLogic = () => {
    //     // If we scroll to top, we know to set the path properly
    //     if (loading) return // Don't process anything between page transitions
    //     if ($pageStore.params.notation === undefined) {
    //         // Don't process anything if this gets called while exiting the page?
    //         console.warn("$params.notation undefined")
    //         return
    //     }

    //     // This allows for the first load of any page to skip.
    //     // By placing the first setScroll/setPage in the loading function
    //     // we let the app know what page we're moving to before
    //     // we actually get there. This allows things like the top
    //     // nav bar to display properly before the page is loaded.
    //     // But we need to disable the first load of this function otherwise
    //     // it will make an unnecessary write to what was already written
    //     // to the DB when the page began loading.
    //     if (pageAndScrollAlreadySaved) {
    //         pageAndScrollAlreadySaved = false
    //         return
    //     }

    //     if (scrollContainer.scrollTop == 0) {
    //         setScroll(0)
    //         setPath($pageStore.params.notation, false)
    //     } else {
    //         // Debounce logic, so not to overwhelm DB
    //         const scrollTopPX = scrollContainer.scrollTop
    //         setScroll(scrollTopPX)
    //     }
    // }

    // onMount(() => {
    //     scrollContainer.addEventListener("scroll", processScrollTabLogic)
    // })

    // onDestroy(() => {
    //     unsetcurrentPageOrRenderItemPath()
    //     scrollContainer.removeEventListener("scroll", processScrollTabLogic)
    // })

    // function isReady(node: Element, ready: Writable<boolean>) {
    //     ready.set(true)
    //     return {
    //         destroy() {
    //             ready.set(false)
    //         },
    //     }
    // }

    // let htmlLoaded = writable(false)

    // // This is for highlightable disable scrolling when dragging,
    // let disableScrollingForHighlightDrag = false

    let allowScrollPathSaving = false

    export let hash: string

    /**
     * Scroll
     */
    export let scrollEventHelper: ScrollHelper | null = null

    let localPopWords = keyedPagePopWords
    /**
     * See if we got any pop words from search or highlight
     */
    if (keyedPagePopWords !== null) keyedPagePopWords = null

    onMount(() => {
        scrollEventHelper = new ScrollHelper(scrollContainer)
        scrollEventHelper.addEventListener("scrolltop", () => setPath(renderable.path))
    })
    onDestroy(() => {
        scrollEventHelper?.destroy()
        stop()
    })

    /**
     * Sets the behaviour for the first scroll.
     * If we're moving between tabs, we want this to be
     * fast. If not, we want this to be smooth.
     */
    type ScrollBehaviorOption = "auto" | "instant" | "smooth"
    export let scrollBehaviour: ScrollBehaviorOption = "auto"

    $: processHash(hash)
    function processHash(currentHash: string) {
        if (currentHash === "") {
            allowScrollPathSaving = true
            return
        }
        try {
            // TODO catch this
            const [one, two] = acim.fromRange(currentHash)
            const path = one.firstWord.parentWeight.path
            loadPender.overwrite(async () => {
                console.log("Looking for: data-notation=" + path)
                const res = container.querySelector<HTMLElement>(`[data-notation="${path}"]`)
                console.log({ res })
                if (res !== null) {
                    if (scrollEventHelper === null) throw new Error("Scroll event helper is null!")

                    const offset = getOffsetTopToParent(res, scrollContainer)

                    // This disables the saving of tabs while scrolling, so
                    // we don't get that little glitch of seeing the tab path
                    // go crazy while the scroll animation is happening
                    allowScrollPathSaving = false
                    await scrollEventHelper.scrollTo({
                        behavior: scrollBehaviour,
                        top: offset - 100,
                    })

                    // After first scroll, we always want them to be smooth
                    scrollBehaviour = "smooth"

                    // Allow paths to be saved
                    allowScrollPathSaving = true
                }
            })
        } catch (e) {
            console.warn(e)
        }
    }

    export let renderable: Renderable

    let readerFrame: HTMLDivElement
    let scrollContainer: HTMLDivElement
    let container: HTMLDivElement
    let playerExpanded = false
    let focusAnchorAnimation = 0

    type ReaderFocusAnchor = {
        element: HTMLElement
        top: number
    }

    function findReaderFocusAnchor(): ReaderFocusAnchor | null {
        if (!scrollContainer || !container) return null

        const scrollTop = scrollContainer.getBoundingClientRect().top
        const candidates = container.querySelectorAll<HTMLElement>("[data-notation]")
        for (const element of candidates) {
            const bounds = element.getBoundingClientRect()
            if (bounds.bottom > scrollTop) return { element, top: bounds.top }
        }

        return null
    }

    function holdReaderFocusAnchor(anchor: ReaderFocusAnchor | null) {
        cancelAnimationFrame(focusAnchorAnimation)
        if (!anchor || !scrollContainer) return

        const startedAt = performance.now()
        const keepPosition = () => {
            const difference = anchor.element.getBoundingClientRect().top - anchor.top
            if (Math.abs(difference) > 0.5) scrollContainer.scrollTop += difference

            if (performance.now() - startedAt < 280) {
                focusAnchorAnimation = requestAnimationFrame(keepPosition)
            }
        }

        focusAnchorAnimation = requestAnimationFrame(keepPosition)
    }

    async function setReaderFocus(focused: boolean) {
        if (get(readerFocusMode) === focused) return

        const anchor = findReaderFocusAnchor()
        if (focused) {
            $navigatorOpen = false
            $sideMenuOpen = false
            globalSelectHandler.cancelAll()
        }

        $readerFocusMode = focused
        await tick()
        holdReaderFocusAnchor(anchor)
    }

    function toggleReaderFocus() {
        void setReaderFocus(!get(readerFocusMode))
    }

    function handleAudiobookActivation() {
        if (get(readerFocusMode)) void setReaderFocus(false)
    }

    function pinchIsOverReaderText(event: ReaderPinchEvent) {
        const x = Math.min(1, Math.max(0, event.centerX)) * window.innerWidth
        const y = Math.min(1, Math.max(0, event.centerY)) * window.innerHeight
        const target = document.elementFromPoint(x, y)
        return target instanceof Element && target.closest(".reader-focus-gesture-surface") !== null
    }

    function handleReaderPinch(event: ReaderPinchEvent) {
        if (!pinchIsOverReaderText(event)) return

        if (event.direction === "zoomIn" && !get(readerFocusMode)) {
            void setReaderFocus(true)
        } else if (event.direction === "zoomOut" && get(readerFocusMode)) {
            void setReaderFocus(false)
        }
    }

    $: {
        const readerNavigatorWidth = `${$navigatorWidth}px`
        if (readerFrame) {
            readerFrame.style.setProperty("--reader-navigator-width", readerNavigatorWidth)
        }
        if (container) {
            container.style.setProperty("--reader-navigator-width", readerNavigatorWidth)
        }
    }

    function hoveredOverParagraph(path: string) {
        if (allowScrollPathSaving === true) setPath(path)
    }

    const redrawEventDispatcher = new RedrawEventDispatcher()

    let pageBodyContainerWidth = 0
    $: redrawEventDispatcher.resize(pageBodyContainerWidth)

    // By putting this at the bottom, we make sure all previous
    // onMounts fire first!
    let loaded = writable(false)
    const loadPender = new StorePender(loaded)
    onMount(() => {
        $loaded = true
    })

    onMount(() => {
        let destroyed = false
        let disableReaderGestures = async () => {}
        const destroyLowercaseHotkey = registerHotKeyTap("f", toggleReaderFocus)
        const destroyUppercaseHotkey = registerHotKeyTap("F", toggleReaderFocus)
        const destroyEscapeHotkey = registerHotKeyTap("Escape", () => {
            if (get(readerFocusMode)) void setReaderFocus(false)
        })

        void enableReaderGestures(handleReaderPinch)
            .then((disable) => {
                if (destroyed) void disable()
                else disableReaderGestures = disable
            })
            .catch((error) => console.warn("Unable to enable native reader gestures", error))

        return () => {
            destroyed = true
            cancelAnimationFrame(focusAnchorAnimation)
            destroyLowercaseHotkey()
            destroyUppercaseHotkey()
            destroyEscapeHotkey()
            void disableReaderGestures()
            exitReaderFocus()
        }
    })
</script>

<!-- {#if loading} -->
<!-- <Loader message="" opacity={0} duration={2000} /> -->
<!-- {/if} -->

<div
    class="reader-frame"
    class:focus-mode={$readerFocusMode}
    bind:this={readerFrame}
    in:fade={{ duration: 100, delay: 100 }}
    out:fade={{ duration: 100 }}
>
    <ReadingFrameHeader page={renderable} />
    <div
        id="scrollWrapper"
        class={scrollLockClass}
        class:audio-visible={$audioItem}
        class:audio-expanded={playerExpanded}
        bind:this={scrollContainer}
        use:scrollTopListener
    >
        <ReadingContentsButton />
        <div
            bind:this={container}
            class="text-container reader reader-focus-gesture-surface"
            use:styleFontSize
        >
            <div
                class="pageBodyContainer w-full relative {contextScrollContainerClass}"
                bind:clientWidth={pageBodyContainerWidth}
            >
                {#if false}
                    <div>
                        <!-- Error message -->
                    </div>
                {:else}
                    <div class="topSpacer" />
                    <div
                        class="z-1 relative px-2"
                        use:watchParagraphs={{ process: hoveredOverParagraph }}
                        use:setupAudioOnNode={{
                            path: renderable.path,
                            onActivate: handleAudiobookActivation,
                        }}
                        use:attachHighlighterListener={{
                            redrawEventDispatcher,
                            settings: {
                                popWords: localPopWords,
                            },
                        }}
                    >
                        {@html htmlRenderItems(renderable.renderItems)}
                    </div>
                    <NextButton page={renderable} />
                    <div class="bottomSpacer" />
                {/if}
            </div>
        </div>
    </div>
</div>

{#if $readerFocusMode}
    <ReaderFocusExitButton exit={() => void setReaderFocus(false)} />
{/if}

<Player
    bind:expanded={playerExpanded}
    contextLabel={renderable.path}
    bottomClearance="0rem"
    focusHidden={$readerFocusMode}
/>

<style>
    .reader-frame {
        --reader-navigator-width: 0px;
        --reader-navigator-gap: clamp(0px, var(--reader-navigator-width), 0.75rem);
        --reader-navigator-clearance: calc(
            var(--reader-navigator-width) + var(--reader-navigator-gap)
        );

        position: relative;
        z-index: 1;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        width: 100%;
        height: 100%;
        min-width: 0;
        min-height: 0;
        background: var(--background);
        transition: grid-template-rows 0.24s ease;
    }

    .reader-frame.focus-mode {
        grid-template-rows: 0 minmax(0, 1fr);
    }

    .reader-frame :global(.reading-frame-header) {
        opacity: 1;
        transform: translateY(0);
        visibility: visible;
        transition:
            transform 0.24s ease,
            opacity 0.18s ease,
            visibility 0s;
    }

    .reader-frame.focus-mode :global(.reading-frame-header) {
        opacity: 0;
        pointer-events: none;
        transform: translateY(-100%);
        visibility: hidden;
        transition:
            transform 0.24s ease,
            opacity 0.18s ease,
            visibility 0s 0.24s;
    }

    #scrollWrapper {
        --reader-mobile-bottom-dock-clearance: var(--app-reader-tabs-dock-height, 0rem);
        --reader-mobile-contents-clearance: 0rem;
        --reader-scroll-content-edge-padding: 1rem;
        --reader-floating-button-gap: 0.75rem;
        --reader-bottom-dock-clearance: 0rem;
        --reader-sticky-bottom-clearance: max(
            var(--reader-scroll-content-edge-padding),
            calc(var(--reader-bottom-dock-clearance) + var(--reader-floating-button-gap))
        );
        --reader-final-scroll-clearance: max(
            0rem,
            calc(var(--reader-sticky-bottom-clearance) - var(--reader-scroll-content-edge-padding))
        );

        height: 100%;
        min-height: 0;
        width: 100%;
        background: var(--background);
        position: relative;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 1;
    }

    #scrollWrapper :global(.bottomSpacer) {
        height: var(--reader-final-scroll-clearance);
    }

    #scrollWrapper.audio-visible {
        --reader-bottom-dock-clearance: calc(6.5rem + var(--safe-area-inset-bottom, 0rem));
    }

    #scrollWrapper.audio-visible.audio-expanded {
        --reader-bottom-dock-clearance: calc(12rem + var(--safe-area-inset-bottom, 0rem));
    }

    .reader-frame.focus-mode #scrollWrapper,
    .reader-frame.focus-mode #scrollWrapper.audio-visible,
    .reader-frame.focus-mode #scrollWrapper.audio-visible.audio-expanded {
        --reader-bottom-dock-clearance: 0rem;
    }

    .reader-frame :global(.mobile-contents-tab),
    .reader-frame :global(.next-buttons-container) {
        opacity: 1;
        visibility: visible;
        transition:
            transform 0.24s ease,
            opacity 0.18s ease,
            visibility 0s;
    }

    .reader-frame.focus-mode :global(.mobile-contents-tab) {
        opacity: 0;
        pointer-events: none;
        transform: translateX(-100%);
        visibility: hidden;
        transition:
            transform 0.24s ease,
            opacity 0.18s ease,
            visibility 0s 0.24s;
    }

    .reader-frame.focus-mode :global(.next-buttons-container) {
        height: 0;
        margin: 0;
        opacity: 0;
        pointer-events: none;
        transform: translateY(100%);
        visibility: hidden;
        transition:
            transform 0.24s ease,
            opacity 0.18s ease,
            visibility 0s 0.24s;
    }

    .reader-frame.focus-mode #scrollWrapper :global(.topSpacer) {
        height: calc(var(--safe-area-inset-top, 0rem) + 1rem);
    }

    @media only screen and (max-width: 1153px) {
        #scrollWrapper {
            --reader-bottom-dock-clearance: var(--reader-mobile-bottom-dock-clearance);
        }

        #scrollWrapper.audio-visible,
        #scrollWrapper.audio-visible.audio-expanded {
            --reader-bottom-dock-clearance: var(--reader-mobile-bottom-dock-clearance);
        }
    }

    :global(.reader-layout-compact) .reader-frame {
        grid-template-rows: minmax(0, 1fr);
    }

    :global(.reader-layout-compact) #scrollWrapper {
        --reader-mobile-contents-clearance: calc(var(--safe-area-inset-top, 0rem) + 2.75rem);
        --context-menu-top-offset: var(--safe-area-inset-top, 0rem);
    }

    :global(.reader-layout-compact) .reader-frame #scrollWrapper :global(.topSpacer) {
        height: max(var(--reader-mobile-contents-clearance), var(--safe-area-inset-top, 0rem));
    }

    @media (prefers-reduced-motion: reduce) {
        .reader-frame,
        .reader-frame :global(.reading-frame-header),
        .reader-frame :global(.mobile-contents-tab),
        .reader-frame :global(.next-buttons-container) {
            transition: none;
        }
    }
</style>
